import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
export const LegalNoticePage = () => {
  return <>
      <PageSeo title="Legal Notice" description="Legal Notice. English language for professional communication and success on international scene." noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Legal Notice (Impressum)</h1>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <p>This website is operated by:</p>

          <ul className="list-inside list-disc space-y-1">
            <li>
              <strong>Individual Entrepreneur:</strong> Anna Sladkikh
            </li>
            <li>
              <strong>Identification (VAT) Number:</strong> 304729774
            </li>
            <li>
              <strong>Address:</strong> Georgia, Tbilisi, Krtsanisi District, Nino and Ilia Nakashidze Street, №1,
              (Avlevi Building), Apartment №3, Building №3
            </li>
            <li>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${process.env.NEXT_PUBLIC_GMAIL}`}>{process.env.NEXT_PUBLIC_GMAIL}</a>
            </li>
            <li>
              <strong>Bank Details:</strong>
            </li>
          </ul>

          <h2 className="mt-5 font-bold">Disclaimer</h2>
          <p>
            The information provided on this website is for general informational purposes only. While we strive to
            ensure the accuracy and timeliness of the content, we cannot guarantee it is always up-to-date or complete.
            This website does not facilitate transactions or contractual agreements.
          </p>

          <h2 className="mt-5 font-bold">Copyright Notice</h2>
          <p>
            All content, including texts, images, and graphics, on this website is subject to copyright laws.
            Unauthorized reproduction, modification, or distribution of any material is prohibited unless explicitly
            permitted by the copyright owner.
          </p>

          <h2 className="mt-5 font-bold">Dispute Resolution</h2>
          <p>
            The European Commission provides a platform for online dispute resolution (ODR):
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>
            . We are not obligated or willing to participate in dispute resolution proceedings before a consumer
            arbitration board.
          </p>
        </section>
      </Article>
    </>;
};
LegalNoticePage.Layout = MainLayout;